import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

function PatientProtectedRoutes({ component: Component, ...restOfProps }) {
  const myrole = useSelector((state) => state?.Auth?.role);

  const isLogin = useSelector((state) => state.Auth.isLogin);
  return <>{isLogin && myrole == "patient" ? <Outlet /> : <Navigate to="/" />}</>;
}

export default PatientProtectedRoutes;
